import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AssortmentService, AuthService, Assortment } from 'gung-standard';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TyloAssortmentServiceService extends AssortmentService {
  constructor(http: HttpClient, authService: AuthService, private translateService: TranslateService) {
    super(http, authService);
  }

  protected mapAssortment(assortment: Assortment): Assortment {
    const superMapped = super.mapAssortment(assortment);

    const lang = this.translateService.currentLang;

    superMapped.extra = superMapped.extra || {};
    superMapped.extra = {
      ...superMapped.extra,
      i18n: {
        ...superMapped.extra.i18n,
        ...superMapped.extra.i18
      }
    };
    if (superMapped.extra && superMapped.extra.i18n && superMapped.extra.i18n[lang]) {
      superMapped.name = superMapped.extra.i18n[lang].assortmentName || superMapped.name;
    }

    if (superMapped.children && superMapped.children.length > 0) {
      superMapped.children = [...superMapped.children.map(child => this.mapAssortment(child))];
    }

    return superMapped;
  }

    getAssortmentRecursiveCustomerFilteredNoProducts(assortmentId: string, customerId: string): Observable<Assortment> {
      return this.http
        .get<Assortment>('json/feature/assortment-recursive-customer-filtered-no-products/' + assortmentId + '?customerId=' + customerId)
        .pipe(map(assortment => this.mapAssortment(assortment)));
    }

}
